import type { MyProfile } from '@shared/profile';
import { request } from '@luna/api';

import { getProfileUrl, getProfileWithInstituteId, setProfileImage } from './useProfile';

export const getMyProfile = async (): Promise<MyProfile> => {
    const profile = await request<MyProfile>(getProfileUrl());

    setProfileImage(profile.offlineKey);
    return getProfileWithInstituteId(profile);
};
